import type { ConfigOrcamento } from "../../../types/orcamento";

interface ConfiguracaoOrcamentoProps {
  config?: ConfigOrcamento;
  onChange: (config: ConfigOrcamento) => void;
}

export default function ConfiguracaoOrcamento({ 
  config, 
  onChange 
}: ConfiguracaoOrcamentoProps) {
  const validacoes = config?.validacoes || {};

  const atualizarValidacao = (campo: string, valor: number) => {
    onChange({
      categorias: config?.categorias || [],
      ...config,
      validacoes: {
        ...validacoes,
        [campo]: valor,
      },
    });
  };

  return (
    <div className="col-span-2 space-y-4 bg-blue-50 p-4 rounded-md">
      <div className="flex items-center gap-2 text-blue-800 mb-2">
        <svg
          className="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
          />
        </svg>
        <span className="font-semibold">
          Configuração da Planilha de Orçamento
        </span>
      </div>

      {/* Validações */}
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Mínimo de Itens
          </label>
          <input
            type="number"
            min="0"
            value={validacoes.min_itens || 1}
            onChange={(e) =>
              atualizarValidacao("min_itens", parseInt(e.target.value) || 1)
            }
            className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Máximo de Itens
          </label>
          <input
            type="number"
            min="1"
            value={validacoes.max_itens || 50}
            onChange={(e) =>
              atualizarValidacao("max_itens", parseInt(e.target.value) || 50)
            }
            className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Valor Mínimo Total (R$)
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={validacoes.valor_minimo_total || 1000}
            onChange={(e) =>
              atualizarValidacao(
                "valor_minimo_total",
                parseFloat(e.target.value) || 1000
              )
            }
            className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">
            Valor Máximo Total (R$)
          </label>
          <input
            type="number"
            min="0"
            step="0.01"
            value={validacoes.valor_maximo_total || 500000}
            onChange={(e) =>
              atualizarValidacao(
                "valor_maximo_total",
                parseFloat(e.target.value) || 500000
              )
            }
            className="w-full px-2 py-1.5 text-sm border border-gray-300 rounded focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      {/* Info */}
      <div className="bg-blue-100 border border-blue-200 rounded p-3 text-xs text-blue-800">
        <p className="font-semibold mb-1">ℹ️ Categorias Padrão Incluídas:</p>
        <p>
          Pessoal, Material de Consumo, Equipamentos, Serviços de Terceiros,
          Diárias, Outros
        </p>
        <p className="mt-2">
          <strong>Unidades:</strong> Unidade, Caixa, Kg, Metro, m², Hora, Mês,
          Ano
        </p>
      </div>
    </div>
  );
}
